import { render } from "./PanoramaView.vue?vue&type=template&id=bb4ee03c"
import script from "./PanoramaView.vue?vue&type=script&lang=js"
export * from "./PanoramaView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\urbanquater-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__